/**
 * Created by Christof Sander on 07.02.2017.
 */

const utils = require('../lib/utils')
const MD5 = require('md5.js')
// TODO: MARK: BUNDLER
globalThis.jQuery = globalThis.$ = utils.$ = require('jquery')

utils.md5 = function(data){
    return new MD5().update(data).digest('hex')
}

/**
 * uses navigator clipboard api to copy some string to the clipboard if possible.
 * @see https://w3c.github.io/clipboard-apis/#navigator-clipboard
 * @see https://developer.mozilla.org/en-US/docs/Web/API/isSecureContext
 *
 * @param data                      string - data to copy to clipboard.
 * @param showPanelMessage          boolean - show status controllerPanelMessage if possible
 * @returns {Promise<boolean>}      boolean - success
 */
utils.copyToClipboard = async function(data, showPanelMessage = true){
    let success = true

    // check preconditions
    const storage = (window || {}).storage
    if(!data){
        console.error('utils.copyToClipboard() - missing data')
        success = false
    } else if(!(storage || {}).app){
        console.error('utils.copyToClipboard() - missing storage')
        success = false
    } else if(!(navigator || {}).permissions || !(navigator || {}).clipboard){
        if(isSecureContext){
            console.error('utils.copyToClipboard() - missing clipboard api')
        } else {
            console.error('utils.copyToClipboard() - missing clipboard api due to insecure context. are your running on https?')
        }
        success = false
    }
    // check if user grants clipboard usage
    else if(storage.app.copyToClipboardGranted === undefined){
        storage.app.copyToClipboardGranted = false
        try {
            const permissionStatus = await navigator.permissions.query({ name: 'clipboard-write' }) || {}
            if(permissionStatus.state === 'granted'){
                storage.app.copyToClipboardGranted = true
            } else if(permissionStatus.state === 'prompt') {
                delete storage.app.copyToClipboardGranted
                return
            }
        } catch(error){
            console.error('utils.copyToClipboard() - permissions error', error)
            success = false
        }
    }

    // copy to clipboard
    if(storage.app.copyToClipboardGranted){
        try {
            await navigator.clipboard.writeText(data)
            success = true
        } catch(error){
            console.error('utils.copyToClipboard() - copy error', error)
            success = false
        }
    }

    // show panel message if necessary
    if(showPanelMessage){
        let statusController = getComponent('statusController')
        if(statusController){
            if(success){
                statusController.addPanel('status.done.copyToClipboard');
            } else {
                statusController.addPanel('status.problem.copyToClipboard');
            }
        }
    }

    return success
}



///////////////////////////////////////////////
///// ENVIRONMENT HELPERS
///////////////////////////////////////////////

utils.environment.timeouts = {
    clientRefresh: undefined,
    serverRefresh: undefined,
}

/**
 * this function is used to refresh all environment dependent parameters, saves them within storage and call the
 * given update callback if defined.
 *
 * @param initialExecution              boolean - is this the very first execution
 * @param externalDrivenCall            boolean - has this refresh been invoked by external events (like resize or orientation change, ...)
 * @param store                         Store - actual store
 * @param storage                       object - actual storage
 * @param onUpdateCallback              function - optional - on update callback function
 * @param onUpdateCallbackContext       object - optional - context for on update callback function
 * @param environmentExtension          object - optional - static data which should be merged on the caculated environment
 * @param isLandscape					boolean - optional - orientation is landscape (default: true)
 * @private
 */
utils.environment._refresh = (initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape) => {
    if(!storage){
        console.error('environment._refresh() storage missing')
        return
    }

    // init
    initialExecution = !!initialExecution
    externalDrivenCall = !!externalDrivenCall

    const userData = (storage.user || {}).data
    const {
        environment = {},
        serverKnownEnvironment,
    } = userData || {}

    // TODO: remove compatibility stuff after all services have been change to the new format.
    const serviceMediaConfig = (((storage.app || {}).service || {}).config || {}).media || {}
    const {
        styles  = serviceMediaConfig.styles,
        style   = serviceMediaConfig.style,
        layouts = serviceMediaConfig.layout || {},
    } = appConfig.environment || {}

    // update environment
    environment.dimensions      = utils.environment.getDimensions(isLandscape)
    environment.breakPoint      = utils.environment.getBreakPoint(environment, layouts)
    environment.breakPointSize  = 0
    environment.style           = utils.environment.getStyle(environment.breakPoint, (environment.device || {}).type, style)
    if(environmentExtension){
        utils.refReplace(environment, environmentExtension)
    }

    // estimate breakPointSize
    if(layouts[(environment.device || {}).type]){
        if(layouts[(environment.device || {}).type][environment.breakPoint]){
            environment.breakPointSize = layouts[(environment.device || {}).type][environment.breakPoint]
        }
        else {
            environment.breakPointSize = layouts[(environment.device || {}).type]
        }
    }
    else if(layouts[environment.breakPoint]){
        environment.breakPointSize = layouts[environment.breakPoint]
    }

    // save environment within local storage if possible
    if(userData){
        userData.environment = environment
    }

    if(typeof(onUpdateCallback) === 'function'){
        onUpdateCallback.apply(onUpdateCallbackContext || window, [initialExecution, storage, styles, serverKnownEnvironment, environment, externalDrivenCall])
    }
}

/**
 * this function is used to refresh all environment dependent parameters, saves them within storage and call the
 * given update callback if defined.
 * NOTE: after the configured amount if time this function tells the server the new environment of this client.
 *
 * @param initialExecution              boolean - is this the very first execution
 * @param externalDrivenCall            boolean - has this refresh been invoked by external events (like resize or orientation change, ...)
 * @param store                         Store - actual store
 * @param storage                       object - actual storage
 * @param onUpdateCallback              function - optional - on update callback function
 * @param onUpdateCallbackContext       object - optional - context for on update callback function
 * @param environmentExtension          object - optional - static data which should be merged on the caculated environment
 * @param executeImmediatly             boolean - optional - should the environment be refreshed immediately or should be waited until the configured refresh timeout has been reached.
 * @param isLandscape					boolean - optional - orentation is landscape (default: true)
 */
utils.environment.refresh = (initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, executeImmediatly, isLandscape) => {
    // init
    initialExecution = !!initialExecution
    executeImmediatly = !!executeImmediatly
    externalDrivenCall = !!externalDrivenCall
    isLandscape = isLandscape === undefined || !!isLandscape
    const {
        minDeltaUpdate,
        minDeltaServerUpdate,
    } = appConfig.environment || {}

    // refresh environment at most each appConfig.environment.minDeltaUpdate milliseconds
    if(initialExecution || executeImmediatly) {
        utils.environment._refresh(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape)
    }
    else {
        if (utils.environment.timeouts.clientRefresh) clearTimeout(utils.environment.timeouts.clientRefresh)
        utils.environment.timeouts.clientRefresh = setTimeout(function (initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape) {
            utils.environment._refresh(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape)
        }, minDeltaUpdate || 100, initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape)
    }

    // tell server new dimensions at most each appConfig.environment.minDeltaServerUpdate milliseconds
    if (utils.environment.timeouts.serverRefresh){
        clearTimeout(utils.environment.timeouts.serverRefresh)
    }
    utils.environment.timeouts.serverRefresh = setTimeout(function (environment) {
        return utils.$.ajax({
            url: '/~/clientInterface/environment',
            method: 'POST',
            data: JSON.stringify(environment)
        })
    }, initialExecution || executeImmediatly ? 1 : minDeltaServerUpdate || 5000, storage.user.data.environment)
}

/**
 * this function is used to return the dimensions of the browser window.
 *
 * @param isLandscape			boolean - optional - orientation is landscape (default: true)
 * @returns object
 */
utils.environment.getDimensions = (isLandscape) => {
    let $environmentMeasurement
    if(typeof(window) === 'undefined'){
        return {}
    }

    const data = {
        window: {
            width: 	0,
            height: 0
        },
        screen: {
            width:  globalThis.screen.availWidth || globalThis.screen.width,
            height: globalThis.screen.availHeight || globalThis.screen.height
        }
    };

    if(utils.$ && ($environmentMeasurement = utils.$('body > .environmentMeasurement').css('display', 'block')).length > 0){
        data.window = {
            width:  $environmentMeasurement.outerWidth(true),
            height: $environmentMeasurement.outerHeight(true)
        }
        $environmentMeasurement.css('display', 'none')
        if(
            (data.screen.width > data.screen.height && data.window.width < data.window.height)
            ||
            (data.screen.width < data.screen.height && data.window.width > data.window.height)
        ){
            data.screen = {
                width: 	data.screen.height,
                height: data.screen.width,
            };
            isLandscape = !isLandscape
        }

        // flip isLandscape if measured data indicates a wrong value
        if(
            (
                !isLandscape
                &&
                data.window.width > data.window.height
            )
            ||
            (
                isLandscape
                &&
                data.window.width < data.window.height
            )
        ){
            isLandscape = !isLandscape
        }
    }

    if(data.window.width <= 0 || data.window.height <= 0) {
        data.window = {
            width:  Math.max(document.documentElement.clientWidth, globalThis.innerWidth || 0),
            height: Math.max(document.documentElement.clientHeight, globalThis.innerHeight || 0)
        }
        if(data.window.width > data.screen.width || data.window.height > data.screen.height){
            data.window.width = data.screen.width
            data.window.height = data.screen.height
        }
    }


    data.isLandscape = isLandscape

    // TODO: POIA: Screen.orientation
    if(window !== undefined){
        data.orientation = window.orientation
    }

    // change values orientation dependent if necessary
    if(
        (
            !isLandscape
            &&
            data.window.width > data.window.height
        )
        ||
        (
            isLandscape
            &&
            data.window.width < data.window.height
        )
    ){
        data.screen = {
            width: 	data.screen.height,
            height: data.screen.width,
        }
        data.window = {
            width: 	data.window.height,
            height: data.window.width,
        }
    }

    return data
}

/**
 * this function returns the actual breakPoint according to the given environment-data and the available appConfig.media.layout
 *
 * @param   environment     object - actual users' environment
 * @param   layouts         object - layouts defined in serviceConfig
 * @returns                 string - breakPoint (default: 'm')
 */
utils.environment.getBreakPoint = (environment, layouts) => {
    const defaultBreakPoint = appConfig.environment.defaultBreakPoint || 'l'
    if(!((environment || {}).device || {}).type || !layouts || !(((environment || {}).dimensions || {}).window || {}).width){
        return defaultBreakPoint
    }

    const width = environment.dimensions.window.width
    let takeMaxWidth = true
    const actualBreakPoint = {
        width:  Number.MAX_SAFE_INTEGER,
        name:   defaultBreakPoint
    }
    const maxBreakPoint = {
        width:  -1,
        name:   defaultBreakPoint
    }

    // NOTE:    this breakPoint detection excludes the maxWidth configured for the actual breakPoint.
    //          this means: 768 <= m < 1024
    const breakPoints = layouts[environment.device.type] || layouts
    for(const [breakPoint, breakPointMaxWidth] of Object.entries(breakPoints || {})){
        if(width < breakPointMaxWidth){
            takeMaxWidth = false
            if(breakPointMaxWidth <= actualBreakPoint.width){
                actualBreakPoint.width  = breakPointMaxWidth
                actualBreakPoint.name   = breakPoint
            }
        }
        else if(takeMaxWidth && maxBreakPoint.width < breakPointMaxWidth) {
            maxBreakPoint.width = breakPointMaxWidth
            maxBreakPoint.name  = breakPoint
        }
    }

    if(takeMaxWidth){
        return maxBreakPoint.name
    }
    return actualBreakPoint.name
}

/**
 * this function returns the actual style according to the given environment-data and the available appConfig.environment.style
 * NOTE:    if the actual device is defined within the style-config as object containing a NON-complete list of
 *          the available breakPoints within this device-layout, then the default style will be returned!
 *
 * @param   breakPoint      string - actual users' breakPoint
 * @param   device          string - actual users' device
 * @param   style           object - style defined in appConfig.environment
 * @returns                 string - style (default: 'desktop')
 */
utils.environment.getStyle = (breakPoint, device, style) => {
    let actualStyle = 'desktop'
    if(!style){
        return actualStyle
    }
    breakPoint  = breakPoint || appConfig.environment.defaultBreakPoint || 'l'
    device      = device || 'desktop'

    if(typeof(style) === 'string'){
        actualStyle = style
    }
    else if(style[device]){
        if(typeof(style[device]) === 'string'){
            actualStyle = style[device]
        }
        else if(style[device][breakPoint]){
            actualStyle = style[device][breakPoint]
        }
    }

    return actualStyle
}



module.exports = utils